module.exports = __webpack_public_path__ + "static/media/example-1.5617ecf4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/Offer/example-1.jpg
// module id = 398
// module chunks = 0